export const CARD_SHORT_CHARS = 180;

/** The first sentence or two, ending at a full stop, within about 180 characters. */
export function shortRemarks(text) {
  const full = String(text || '').replace(/\s+/g, ' ').trim();
  if (full.length <= CARD_SHORT_CHARS) return full;
  const sentences = full.match(/[^.!?]+[.!?]+(?=\s|$)/g) || [];
  let out = '';
  for (const s of sentences) {
    if (out && (out + s).length > CARD_SHORT_CHARS) break;
    out += s;
  }
  out = out.trim();
  // One long first sentence is fine up to a point; past that, cut at a word.
  if (out && out.length <= CARD_SHORT_CHARS + 60) return out;
  const cut = full.slice(0, CARD_SHORT_CHARS);
  const space = cut.lastIndexOf(' ');
  return `${space > 0 ? cut.slice(0, space) : cut}…`;
}
